<template>
  <div class="user-menu p-flex p-ai-center p-gap-2">
    <ThemeToggle @theme-changed="onThemeChanged" />
    <Button 
      icon="pi pi-user" 
      class="p-button-text p-button-rounded p-button-lg p-text-white user-menu-button"
      @click="toggleUserMenu"
    />
    
    <OverlayPanel ref="userMenuPanel" class="user-menu-panel">
      <div class="user-menu-options">
        <div 
          v-for="action in userActions" 
          :key="action.value"
          class="user-menu-option"
          @click="handleUserAction(action)"
        >
          <i :class="action.icon"></i>
          <span>{{ action.label }}</span>
        </div>
      </div>
    </OverlayPanel>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ThemeToggle from './ThemeToggle.vue'

export default {
  name: 'UserMenu',
  components: {
    ThemeToggle
  },
  data() {
    return {
      userActions: [
        { label: 'Профіль', value: 'profile', icon: 'pi pi-user' },
        { label: 'Налаштування', value: 'settings', icon: 'pi pi-cog' },
        { label: 'Вийти', value: 'logout', icon: 'pi pi-sign-out' }
      ]
    }
  },
  computed: {
    ...mapState(['currentUser']),
  },
  methods: {
    ...mapActions(['logout']),
    toggleUserMenu(event) {
      this.$refs.userMenuPanel.toggle(event);
    },
    
    handleUserAction(action) {
      if (action.value === 'logout') {
        this.logout()
        this.$router.push('/login')
      } else if (action.value === 'profile') {
        this.$router.push('/profile')
      } else if (action.value === 'settings') {
        this.$router.push('/settings')
      }
      this.$refs.userMenuPanel.hide();
    },
    
    onThemeChanged(newTheme) {
      this.$emit('theme-changed', newTheme)
    }
  }
}
</script>

<style scoped>
/* User menu button styling */
.user-menu-button {
  background: transparent !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  transition: all 0.2s ease;
}

.user-menu-button:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.4) !important;
}

/* User menu panel styling */
.user-menu-panel {
  min-width: 200px;
}

.user-menu-options {
  padding: 0.5rem 0;
}

.user-menu-option {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  color: var(--text-color);
}

.user-menu-option:hover {
  background: var(--surface-hover);
}

.user-menu-option i {
  font-size: 1rem;
  color: var(--text-color-secondary);
}

/* PrimeVue component overrides for user menu */
:deep(.p-dropdown) {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

:deep(.p-dropdown:not(.p-disabled):hover) {
  border-color: rgba(255, 255, 255, 0.4);
}

:deep(.p-dropdown .p-dropdown-trigger) {
  color: white;
}

:deep(.p-dropdown .p-dropdown-label) {
  color: white;
}

:deep(.p-dropdown .p-dropdown-label.p-placeholder) {
  color: rgba(255, 255, 255, 0.7);
}

:deep(.p-dropdown-panel) {
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-lg);
}

:deep(.p-dropdown-panel .p-dropdown-items .p-dropdown-item) {
  color: var(--text-color);
  padding: 0.75rem 1rem;
  transition: background-color 0.2s ease;
}

:deep(.p-dropdown-panel .p-dropdown-items .p-dropdown-item:hover) {
  background: var(--surface-hover);
}

:deep(.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight) {
  background: var(--primary-color);
  color: white;
}
</style>
